import React from 'react';
import { string } from 'prop-types';
import styled from 'styled-components';

import { colors } from '../../constants/styleConstants';

const UnderlineElement = ({ element, fontSize, children }) => {
  const StyledComponent = styled[element]`
    color: ${colors.darkGrey};
    font-size: ${fontSize};
    cursor: pointer;
    text-decoration: underline;
  `;

  return (
    <StyledComponent>
      {children}
    </StyledComponent>
  );
};

UnderlineElement.propTypes = {
  element: string,
  fontSize: string,
  children: string
};

UnderlineElement.defaultProps = {
  element: 'p',
  fontSize: '1.6em'
};

export default UnderlineElement;



// WEBPACK FOOTER //
// ./src/components/common/UnderlineElement.js